export function propertyLoadMoreInit() {

	const grid = document.querySelector( '.grid-layout__inner' );

	if ( ! grid ) {
		return;
	}

	document.addEventListener( 'mkdoSearchAjaxAppend', function ( event ) {
		if ( ! event.detail.items ) {
			return;
		}

		for ( let item of event.detail.items ) {
			grid.appendChild( item );
		}
	} );
}

// 2024 Property Filter Popout

export function propertyFilterPopout() {

	const propertyFilterPopout      = document.querySelector( '.property-sidebar' );
	const propertyFilterPopoutOpen  = document.querySelector( '.property-index__filterbtn' );
	const propertyFilterPopoutClose = document.querySelector( '.property-sidebar__close-popout' );
	const body                      = document.querySelector( 'body' );
	const siteContainer             = document.querySelector( '.site-container' );
	const pkrdBtnLoading            = document.querySelectorAll( '.pkrd-btn--loading-trigger' );

	if ( ! propertyFilterPopout || ! propertyFilterPopoutOpen || ! propertyFilterPopoutClose ) {
		return;
	}

	window.addEventListener( 'click', function (e) {
		if ( ! propertyFilterPopout.contains( e.target ) && ! propertyFilterPopoutOpen.contains( e.target ) && propertyFilterPopout.classList.contains( 'property-sidebar--active' ) ) {
			propertyFilterPopout.classList.remove('property-sidebar--active');
			body.classList.remove('property-popout-active');
		}
	});

	propertyFilterPopoutOpen.addEventListener( 'click', function () {
		propertyFilterPopout.classList.add('property-sidebar--active');
		body.classList.add('property-popout-active');
	});

	propertyFilterPopoutClose.addEventListener( 'click', function () {
		propertyFilterPopout.classList.remove('property-sidebar--active');
		body.classList.remove('property-popout-active');
	});

	if ( pkrdBtnLoading && siteContainer ) {
		pkrdBtnLoading.forEach( ( btn ) => {
			btn.addEventListener( 'click', function () {
				siteContainer.classList.add('site-container--loading');
			});
		});
	}
}
